import { TIMEZONE_MAP } from '@/constants'

const EMPTY_TIMEZONE = { code: null, name: '', timeZone: null }

// In-memory, module-level store: the single source of truth for the tenant time zone.
let tenantTimezone = { ...EMPTY_TIMEZONE }

/** Store the tenant time zone from the portal config. Returns false when the code is not mapped. */
export const setTenantTimezone = ({ code, name } = {}) => {
  const timeZone = code ? TIMEZONE_MAP[code] : null
  if (!timeZone) {
    tenantTimezone = { ...EMPTY_TIMEZONE }
    return false
  }
  tenantTimezone = { code, name: name || '', timeZone }
  return true
}

export const clearTenantTimezone = () => {
  tenantTimezone = { ...EMPTY_TIMEZONE }
}

/** IANA time zone name for the tenant, or null when not configured. */
export const getTenantTimeZone = () => tenantTimezone.timeZone

export const getTenantTimezoneCode = () => tenantTimezone.code

export const getTenantTimezoneName = () => tenantTimezone.name

export const hasTenantTimezone = () => Boolean(tenantTimezone.timeZone)
